module.exports = __webpack_public_path__ + "static/media/LOGO-3-RGB.7d13093c.png";